import * as React from 'react';
import { Dispatch } from 'redux';
import { CreateGeneratorJobRequest as FormData, ParticipantViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class CreateGeneratorJobRequest extends BaseApiPostRequest<
  ParticipantViewModel,
  EntityNormalizers.NormalizedEntityArray<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(formData: FormData, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/generator-jobs`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipantsArray;
  }
}
